
import _ from "underscore";

import i1 from "../static/img/pm/pm1.png";
import i2 from "../static/img/pm/pm3.png";
import i3 from "../static/img/pm/pm4.png";
import i4 from "../static/img/pm/pm6.png";
import i5 from "../static/img/pm/pm7.png";
import i6 from "../static/img/pm/pm8.png";
import i7 from "../static/img/logo/ss10.png";
import i8 from "../static/img/logo/ss4.png";
import i9 from "../static/img/logo/ss6.png";
import i11 from "../static/img/logo/ss12.png";
import i12 from "../static/img/simitri/ipad6.png";
import i13 from "../static/img/simitri/ipad2.png";
import i14 from "../static/img/simitri/ipad4.png";
import i15 from "../static/img/simitri/ipad5.png";
import i16 from "../static/img/simitri/ipad7.png";
import i17 from "../static/img/simitri/ipad8.png";
import i18 from "../static/img/shockwaves/slide7.png";
import i20 from "../static/img/lego/parsetree2.png";
import i21 from "../static/img/lego/robot.jpg";
import i22 from "../static/img/lego/slide2.png";
import i23 from "../static/img/lego/slide4.png";
import i25 from "../static/img/hottopics/slide2.png";
import i26 from "../static/img/hottopics/slide3.png";
import i27 from "../static/img/rtm/slide1.png";
import i28 from "../static/img/rtm/slide8.png";
import i29 from "../static/img/rtm/slide10.png";
import i30 from "../static/img/rtm/slide11.png";
import i31 from "../static/img/rtm/slide12.png";
import i32 from "../static/img/rtm/slide6.png";

export default [
  i1, i2, i3, i4, i5, i6, i7, i8, i9,
  i11, i12, i13, i14, i15, i16, i17, i18, i20,
  i21, i22, i23, i25, i26, i27, i28, i29, i30, i31, i32
];







// WEBPACK FOOTER //
// ./src/imgs.js